import { Flex, Text, ErrorIcon, FlexProps } from 'vvs-uikit'
import styled, { useTheme } from 'styled-components'

const ErrorAlert = ({ children, ...props }: { children: React.ReactNode } & FlexProps) => {
  const theme = useTheme()
  return (
    <ErrorAlertFlex {...props}>
      <ErrorIcon fill={theme.colors.failure} />
      <Text color="black">{children}</Text>
    </ErrorAlertFlex>
  )
}

export default ErrorAlert

const ErrorAlertFlex = styled(Flex)`
  padding: 1em;
  background-color: ${({ theme }) => theme.colors.failureLight};
  border-radius: 12px;
  gap: 0.5em;
`
